export class QualityItemDetails {
  constructor({
        id= null, 
        itemId= ``,
        itemCode= ``, 
        itemName= ``, 
        craftType= ``,
        checkType= ``,
        measureUp=null,
        measureDown=null,
        parameterId='',
        parameterCode='',
        parameterName='',
        parameterUnit=''


                 
    } = {}) {
    this.id = id;
    this.itemId=itemId;
    this.itemCode = itemCode;
    this.itemName=itemName;
    this.craftType = craftType;
    this.checkType=checkType;
    this.measureUp=measureUp;
    this.measureDown=measureDown;
    this.parameterId=parameterId;
    this.parameterCode=parameterCode;
    this.parameterName=parameterName;
    this.parameterUnit=parameterUnit;
        
  }
}
export function gridFields() {
  return Object.freeze([ 
    
      {
        key: 'parameterCode',
        label: 'lbl.qualityItemDetails.parameterCode',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'parameterName',
        label: 'lbl.qualityItemDetails.parameterName',
        sortable: true,
        form: {
          type: 'input'
        }
      },  
      {
        key: 'itemCode',
        label: 'lbl.qualityItemCode',
        sortable: true,
        notInTable:true,
        form: {
          type: 'input'
        }
    },
      {
        key: 'itemName',
        label: 'lbl.qualityItemName',
        sortable: true,
        notInTable:true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'craftType',
        label: 'lbl.qualityItemCraftType',
        sortable: true,
        notInTable:true,
        form: {
          type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'p', text:  'lbl.qualityItem.pelletizing' },  
                { value: 's', text:  'lbl.qualityItem.smelt' }
            
                                 
              ]     
        }
      },
      {
        key: 'checkType',
        label: 'lbl.qualityItemCheckType',
        sortable: true,
        notInTable:true,
        form: {
          type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'material', text:  'lbl.qualityItem.material' },  
                { value: 'process', text:  'lbl.qualityItem.process' },
                { value: 'production', text:  'lbl.qualityItem.production' },
            
                                 
              ]     
        }
      },
      {
        key: 'measureUp',
        label: 'lbl.qualityItemDetails.measureUp',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'measureDown',
        label: 'lbl.qualityItemDetails.measureDown',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'parameterUnit',
        label: 'lbl.qualityItemDetails.parameterUnit',
        sortable: true,
        form: {
          type: 'input'
        }
      }
     
     
     
     
  ]);
}

export const fields = Object.freeze(Object.keys(new QualityItemDetails()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.itemCodeFilter',
  'filter.itemNameFilter',

];
export const filter = {
  'itemCodeFilter': "",
  'itemNameFilter': "",
  
  
};